import { render, staticRenderFns } from "./Password_reset.vue?vue&type=template&id=774e3652&"
import script from "./Password_reset.vue?vue&type=script&lang=js&"
export * from "./Password_reset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports